import { allDayOfferType } from "../../../../../common/utils/helpers/globalConstants";

export const getTimeslotText = (slotTime: string, offer: any, t: any): string => {
  if (offer?.event_type === allDayOfferType) {
    return offer?.directly_bookable ? t("offerDetails.timeslots.bookNow") : t("offerDetails.timeslots.requestNow");
  } else {
    return slotTime;
  }
};
